import {AvalancheRespinState} from '@fantasmagames/slot/src/modules/reels/avalanche/states/AvalancheRespinState';
import {AvalancheReelsEvents} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsEvents';
import {AvalancheReelsModule} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsModule';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {GameAvalancheReelsView} from 'src/avalanche/GameAvalancheReelsView';
import {SymbolPosition} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {AvalancheReelsView} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsView';
import {RespinEvents} from 'src/respin/RespinEvents';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {RespinScatterInfo} from '@fantasmagames/slot/src/logic/SpinResult';

export class GameAvalancheRespinState extends AvalancheRespinState {
	protected setupEvents(): void {
		super.setupEvents();

		this.on(AvalancheReelsView.RESPIN_REMOVING_SYMBOLS_FINISHED, this.onRespinSymbolsRemovalFinished);

		this.on(RespinEvents.LEAVING_SCATTER_AT, this.onLeavingScatterAt);
		this.on(RespinEvents.LEAVING_SYMBOL_AT, this.onLeavingSymbolAt);
		this.on(RespinEvents.RESPIN_REMOVING_FINISHED, this.onRespinFinished);

		this.on(AvalancheReelsEvents.ADDING_NEW_FINISHED, this.onAddingNewFinished);
	}

	protected onLeavingScatterAt(eventID: string, symPos: SymbolPosition): void {
		(this.view as GameAvalancheReelsView).removeScatterAt(symPos);
	}

	protected onLeavingSymbolAt(eventID: string, symPos: SymbolPosition): void {
		(this.view as GameAvalancheReelsView).removeRespinSymbol(symPos, null, null);
	}

	protected onRespinFinished(): void {
		this.module.timeUtils.createTimer(() => {
			const respinScatters: RespinScatterInfo[] = (this.module.logic as GameRecodeLogic).getSpinResult().respinScatters;
			const removePositions: SymbolPosition[] = [];
			for (const scatterInfo of respinScatters) {
				removePositions.push(scatterInfo.respinScatterPosition);
				removePositions.push(...scatterInfo.respinSymbols);
			}

			(this.view as GameAvalancheReelsView).removeRespinSymbolsFromReels(removePositions);
			this.view.fillVoidAfterRemoval();

			this.emit(AvalancheReelsEvents.SYMBOLS_RESPIN_STARTED);
		}, 300);
	}

	protected startAddingNewSymbols(): void {
		const logic = this.module.logic as GameRecodeLogic;
		(this.view as GameAvalancheReelsView).startAddingNewSymbolsWithExpectedWin(
			logic.getSpinResult().reels,
			logic.getSpinResult().symbolsToAdd,
			logic.getSpinResult().winLines,
		);
	}

	protected onRespinSymbolsRemovalFinished(): void {
		this.emit(ReelsEvents.REELS_RESPIN_STARTED);
	}

	protected onAddingNewFinished(): void {
		const logic: GameRecodeLogic = this.module.logic as GameRecodeLogic;
		logic.startNextRound();

		this.module.gotoState(AvalancheReelsModule.BASIC_STATE);
		this.emitDelayed(AvalancheReelsEvents.SYMBOLS_RESPIN_FINISHED);
	}
}



// WEBPACK FOOTER //
// ./src/avalanche/states/GameAvalancheRespinState.ts